import React, { useState, useEffect } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";
import SidebarLink from "./SidebarLink";
import { useLocation } from "react-router-dom";

const GroupedSidebarLink = ({ icon: Icon, text, links }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Verifica se algum link do grupo está ativo
  const isActiveGroup = links.some(link => link.link === location.pathname);

  // Abre o grupo automaticamente quando estiver ativo
  useEffect(() => {
    if (isActiveGroup) {
      setIsOpen(true);
    }
  }, [isActiveGroup, location.pathname]);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button 
        onClick={toggleOpen} 
        className="w-full group block hover:bg-zinc-800 transition-colors"
      >
        <div className="pl-7 py-3 gap-7 flex items-center w-max">
        <Icon className={`min-w-[24px] w-6 h-6 transition-colors duration-200 ${isActiveGroup ? 'text-amber-500' : "text-white group-hover:text-amber-500"}`} />
          <span className={`group-hover:-translate-x-2 transition-all duration-200 font-medium tracking-tight group-hover:text-amber-500 flex-1 text-left ${
            isActiveGroup ? 'text-amber-500' : 'text-white'
          }`}>
           {text}
          </span>
          {isOpen ? (
            <TbChevronUp className={`w-6 h-6 ${isActiveGroup ? 'text-amber-500' : "text-white group-hover:text-amber-500"}`} />
          ) : (
            <TbChevronDown className={`w-6 h-6 ${isActiveGroup ? 'text-amber-500' : "text-white group-hover:text-amber-500"}`} />
          )}
        </div>
      </button>
      {isOpen && (
        <div className="pl-4">
          {links.map((link, index) => (
            <SidebarLink
              key={index}
              link={link.link}
              Icon={link.Icon}
              text={link.text}
              
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default GroupedSidebarLink;